(function () {
    var genericTruncate = {
        texts: {
            listenersAdded: false,
        },

        init: function () {
            genericTruncate.truncateAll();
            genericTruncate.control();
            genericTruncate.addEventListeners();
        },

        control: function () {},

        addEventListeners: function () {
            if (genericTruncate.texts.listenersAdded) return;

            $('.modal').on('shown.bs.modal', function () {
                genericTruncate.init();
            });

            genericTruncate.texts.listenersAdded = true;
        },

        truncate: {
            text: function ($ele) {
                $ele.each(function (index) {
                    var $elem = $(this),
                        lines = typeof $elem.data('lines') === 'undefined' ? '1' : $elem.data('lines'),
                        seeMoreLink = typeof $elem.data('more') === 'undefined' ? true : $elem.data('more'),
                        seeMoreText =
                            typeof $elem.data('more-text') === 'undefined' ? 'Read More' : $elem.data('more-text'),
                        seeLessText =
                            typeof $elem.data('less-text') === 'undefined' ? 'Read Less' : $elem.data('less-text'),
                        seeMoreHtml = typeof $elem.data('more-html') === 'undefined' ? '' : $elem.data('more-html'),
                        seeLessHtml = typeof $elem.data('less-html') === 'undefined' ? '' : $elem.data('less-html'),
                        ellipsisChar = typeof $elem.data('ellipsis') === 'undefined' ? '' : $elem.data('ellipsis'),
                        truncateOn = typeof $elem.data('trunc-on') === 'undefined' ? 'all' : $elem.data('trunc-on'),
                        windowWidth = $(window).width(),
                        truncate = true;

                    if (truncateOn === 'all') {
                        truncate = true;
                    } else if (truncateOn === 'desktop') {
                        truncate = windowWidth > UX.grid.screenMd;
                    } else if (truncateOn === 'mobile') {
                        truncate = windowWidth < UX.grid.screenMd;
                    }

                    //for Read More link take 2 lines
                    //lines += 2;

                    if (truncate) {
                        $elem.css('height', 'auto');
                        $elem.truncate({
                            lines: lines,
                            type: 'text',
                            seeMoreLink: seeMoreLink,
                            seeMoreText: seeMoreText,
                            seeLessText: seeLessText,
                            seeMoreIcon: '',
                            seeLessIcon: '',
                            addClass: 'trunc-done',
                            animation: true,
                            seeMoreHtml: seeMoreHtml,
                            seeLessHtml: seeLessHtml,
                            ellipsisChar: ellipsisChar,
                            readMoreWithSpacebar: true,
                        });
                    }
                });
            },

            shadow: function ($ele) {
                $ele.each(function (index) {
                    var $elem = $(this),
                        seeMoreLink = typeof $elem.data('more') === 'undefined' ? true : $elem.data('more');
                    $elem.css('height', 'auto');
                    $elem.truncate({
                        lines: $elem.data('lines'),
                        type: 'text',
                        seeMoreLink: seeMoreLink,
                        ellipsisChar: '',
                        seeMoreText: 'Read more',
                        seeLessText: 'Less',
                        addClass: 'trunc-done',
                        animation: true,
                        seeMoreHtml: '',
                        seeLessHtml: '',
                        readMoreWithSpacebar: true,
                    });
                });
            },

            list: function ($ele) {
                var $elem = $(this),
                    showRemovedCount =
                        typeof $elem.data('showremovedcount') === 'undefined' ? true : $elem.data('showremovedcount'),
                    position = $elem.data('position');

                $ele.each(function (index) {
                    if ($(this).parents('.disable-truncate').length) {
                        return;
                    }

                    $elem.css('height', 'auto');
                    $elem.truncate({
                        lines: $elem.data('lines'),
                        type: 'list',
                        position: position,
                        ellipsisChar: '...',
                        showRemovedCount: showRemovedCount,
                        seeLessText: '(Less)',
                        addClass: 'trunc-done',
                        animation: true,
                        ignoreCountList: '.label',
                        readMoreWithSpacebar: true,
                    });
                });
            },
        },
        truncateAll: function () {
            genericTruncate.truncate.text($(".truncate-text:not('.trunc-done')"));
            genericTruncate.truncate.shadow($(".truncate-with-shadow:not('.trunc-done')"));
            genericTruncate.truncate.list($(".truncate-list:not('.trunc-done')"));
        },
    };

    UX.genericTruncate = genericTruncate; // add to global namespace
})();
